import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Marketplace">
                <h1>Digital Marketplace Services</h1>
              </div>
              <p className="main_para">
                Build a digital storefront for the modern consumer to increase
                visibility, reach a larger audience, and provide an improved
                customer experience through a convenient and easy-to-use
                platform.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                Create fully-featured online niche marketplaces, attract
                relevant global traffic and turn maximum interactions into
                transactions.
              </p>
              <ul>
                <li>Multi-Vendor Marketplace Development</li>
                <li>Viable Monetization Models</li>
                <li>Big Data and Analytics Access</li>
                <li>Pre-Sales and Post-Sales Support</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
